import {
  DASHBOARD_DATA_PATIENT,
  LOGIN_INIT,
  LOGIN_SUCCESS_ACTION,
  LOG_OUT_ACTION,
  SIGNUP_SUCCESS_ACTION,
  UPDATE_LOGIN,
  DASHBOARD_DATA_DOCTOR,
  TODAY_APPOINTMENT_DOCTOR,
  SET_REDIRECT,
  REMOVE_REDIRECT
} from "../actions/type";

const INITIAL_STATE = {
  login: false,
  user: {},
  countryData: null,
  patientDashboard: null,
  doctorDashboard: null,
  logout: null,
  redirect: null
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOGIN_INIT:
      return { ...state, login: true };
    case LOGIN_SUCCESS_ACTION:
      return {
        ...state,
        user: payload,
        login: true,
      };

    case DASHBOARD_DATA_PATIENT:
      return {
        ...state,
        patientDashboard: payload
      };

    case DASHBOARD_DATA_DOCTOR:
      return {
        ...state,
        doctorDashboard: payload
      };

    case TODAY_APPOINTMENT_DOCTOR:
      return {
        ...state,
        todayAppointment: payload
      }

    case LOG_OUT_ACTION:
      return {
        ...state,
        login: false,
        user: {},
        logout: payload
      };
    case SIGNUP_SUCCESS_ACTION:
      return {
        ...state,
        login: true,
        user: payload,
      };
    case SET_REDIRECT:
      return {
        ...state,
        redirect: payload,
      };
    case REMOVE_REDIRECT:
      return {
        ...state,
        redirect: null,
      };
    case UPDATE_LOGIN:
      return { ...payload }
    case LOG_OUT_ACTION:
      return INITIAL_STATE;
    default:
      return state;
  }
};
